import { useCallback, useRef } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'

import { Mean } from './Mean'

export const MedialThighInput: React.FC = () => {
  const medialThighRef = useRef(evaluationAtom.get()?.medialThigh ?? [])

  const handleUpdateField = useCallback(
    (index: number, value: string) => {
      const newArr = [...medialThighRef.current]
      newArr[index] = +value
      medialThighRef.current = newArr
      patchEvaluationAtom({ medialThigh: newArr })
    },
    [],
  )

  const handleFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(3)
  }, [])

  return (
    <>
      <div className='font-bold xl:font-normal'>Coxa Medial (mm) &nbsp;</div>
      {medialThighRef.current.map((val, index) => (
        <div key={`medialThigh-${index}`}>
          <p className='block xl:hidden mb-2'>Medida {index + 1}</p>
          <MaskedInput
            value={val}
            mask='integer'
            placeholder='0'
            onFocus={handleFocus}
            inputMode='numeric'
            onChange={(v) => handleUpdateField(index, v)}
          />
        </div>
      ))}
      <div>
        <p className='block xl:hidden mb-2'>Média</p>
        <Mean field='medialThigh' />
      </div>
    </>
  )
}
